import Alert from '@storeblocks/alert';
import { LoadingIndicatorSpinner } from '@storeblocks/spinner-loading-indicator';
import { type FC } from 'react';
import { styled } from 'styled-components';

import { useTexts } from '@/hooks/useTexts';

import { EnterSomeSearchCriteriaAlert } from './EnterSomeSearchCriteriaAlert';
import { ReportsTable } from './Table/ReportsTable';
import { Report } from './types/ReportModel';

interface Props {
  reports: Report[];
  isPending?: boolean;
  isError?: boolean;
  isSearchParamsEmpty?: boolean;
}

export const Content: FC<Props> = ({
  reports,
  isPending,
  isError,
  isSearchParamsEmpty,
}) => {
  const texts = useTexts();

  if (isError) {
    return (
      <Alert
        variant="error"
        description={texts.reportsArchivePage.serverError}
        data-test="error-alert"
      />
    );
  }

  if (isPending) {
    return (
      <SpinnerWrapper>
        <LoadingIndicatorSpinner />
      </SpinnerWrapper>
    );
  }

  if (reports.length === 0) {
    return (
      <Alert
        variant="info"
        description={texts.searchResults.noResultsFound}
        data-test="no-result-alert"
      />
    );
  }

  return (
    <>
      <ReportsTable reports={reports} />

      {isSearchParamsEmpty && (
        <EnterSomeSearchCriteriaAlert
          variant="info"
          description={texts.reportsArchivePage.enterSomeCriteria}
        />
      )}
    </>
  );
};

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px;
`;
